import React from 'react';
import {JobCost} from 'components/customer/Job/store/jobApi';
import {
    Item,
    ItemContainer,
    Row,
} from 'components/customer/Confirmation/Checkout/Table';
import {formatPrice} from 'shared/helpers';
import {useAppContext} from 'contexts/ApplicationContext';
import {MoreInfoStatic} from 'shared/components/MoreInfo/MoreInfo';

export const Freight = ({jobCost}: {jobCost?: JobCost | null}) => {
    const {userProfile} = useAppContext();

    if (jobCost?.freightCost) {
        return (
            <Row>
                <td>
                    <ItemContainer>
                        <Item>Freight</Item>
                        <MoreInfoStatic
                            hoverText="Freight"
                            dialogClassName="modal-md"
                            info={userProfile?.manufacturerFreightText || ''}
                        />
                    </ItemContainer>
                </td>
                <td>{formatPrice(jobCost.freightCost, {})}</td>
                <td />
            </Row>
        );
    }
};
